import { render, staticRenderFns } from "./AutomaticUploads.vue?vue&type=template&id=20fe3b7c&"
import script from "./AutomaticUploads.vue?vue&type=script&lang=js&"
export * from "./AutomaticUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QTabPanels,QTabPanel,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QTabPanels,QTabPanel,QSeparator})
